
module.exports = {
  admin: {
    refresh: '刷新',
    address: '地址',
    name: '姓名',
    idcode: '身份證號碼',
    companyName: '慧視醫療',
    adviceTitle: '轉診建議',
    adviceText1: '存在陽性表現，建議眼科復診；',
    adviceText2: '拍攝失敗或分級失敗，建議眼科復診；',
    adviceText3: '定期復診。',
    adviceText4: '此人工智能分級結果只能作為診斷的參考依據，不可取代專業的醫學意見、診斷或治療。',
    information: '基本信息',
    initing: '正在初始化...',
    findFundusSenor: '正在檢查相機與傳感器連接...',
    sensorText: '正在連接傳感器...',
    fundusText: '正在連接相機...',
    back: '返回',
    shutdonw: '關機',
    submit: '確 定',
    cancel: '取 消',
  },
  index: {},
  server: {}
}